import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsServices } from '../../../services/analyticsServices';

/**
 * Generated class for the ConfigurationPaymentPaypalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-payment-paypal',
  templateUrl: 'configuration-payment-paypal.html',
})
export class ConfigurationPaymentPaypalPage {

  paypal_client_id: string = '';

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    public analyticsServices: AnalyticsServices) {
    //notificacion de interes sobre el pay
    if (!this.globals.restaurant.payment_method_paypal_client_id || this.globals.restaurant.payment_method_paypal_client_id == undefined) {
      this.globals.sendIntegrationSlack('PAYMENT METHODS', 'OPEN PAYPAL');
    }
  }

  ionViewWillEnter() {
    if (this.globals.restaurant.payment_method_paypal_client_id != undefined) {
      this.paypal_client_id = this.globals.restaurant.payment_method_paypal_client_id;
    }
  }

  changePaypal(active) {
    if (this.paypal_client_id != '' && this.paypal_client_id != undefined) {
      this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'payment_method_paypal': active,
        'payment_method_paypal_client_id': this.paypal_client_id
      }).then(() => {
        this.globals.restaurant.payment_method_paypal = active;
        this.globals.restaurant.payment_method_paypal_client_id = this.paypal_client_id;
      });
      if (active) {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('pay-paypal-activado'),
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      }
    } else {
      this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'payment_method_paypal': false
      }).then(() => {
        this.globals.restaurant.payment_method_paypal = false;
      });
      let toast = this.toastCtrl.create({
        message: this.translate.instant('pay-paypal-no-podemos-activar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  save() {
    if (this.paypal_client_id != '') {
      this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'payment_method_paypal_client_id': this.paypal_client_id
      }).then(() => {
        if (this.globals.restaurant.payment_method_paypal_client_id !== this.paypal_client_id) {
          //trackingPLGPedidos
          this.analyticsServices.trackingExpPedidos('pay_config', this.globals.tracking_exp['pay_config']);
        }
        this.globals.restaurant.payment_method_paypal_client_id = this.paypal_client_id;
      });
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-guardado-correctamente'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
      this.navCtrl.pop();
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('pay-paypal-completar-campo'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-payment-methods/configuration-payment-paypal/configuration-payment-paypal.ts